export enum Sector {
  'health' = 'health',
}
